"use client";

import { ApolloProvider } from "@apollo/client/react";
import { LocalStorageWrapper, persistCache } from "apollo3-cache-persist";
import { useEffect, useState } from "react";
import { AppShellSkeleton } from "@/components/AppShellSkeleton";
import { makeApolloClient } from "@/lib/apollo/client";
import { useAuth } from "@/providers/AuthProvider";

export function ApolloProviderWrapper({ children }: { children: React.ReactNode }) {
  type ApolloClientType = ReturnType<typeof makeApolloClient>;
  const [client, setClient] = useState<ApolloClientType | null>(null);
  const { isLoading: authLoading } = useAuth();

  useEffect(() => {
    // CRITICAL FIX: Wait for auth to finish loading before creating Apollo Client
    // This ensures the access token is synced to localStorage before Apollo makes any queries
    if (authLoading) {
      return;
    }

    async function initApollo() {
      const apolloClient = makeApolloClient();

      try {
        await persistCache({
          cache: apolloClient.cache,
          storage: new LocalStorageWrapper(window.localStorage),
          key: "apollo-cache-persist",
          maxSize: 1048576 * 2, // 2MB cache size limit
        });
      } catch (error) {
        console.error("Failed to restore Apollo cache from localStorage:", error);
      }

      setClient(apolloClient);
    }

    initApollo();
  }, [authLoading]);

  if (authLoading || !client) {
    return <AppShellSkeleton />;
  }

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
}
